import { Col, Row, Space, Typography } from 'antd';
import type { ReactNode } from 'react';

const { Title, Text } = Typography;

export interface PageHeaderProps {
  /** ページタイトル */
  title: string;
  /** サブタイトル（説明文） */
  subtitle?: ReactNode;
  /** タイトル横のアイコン */
  icon?: ReactNode;
  /** 右側のアクションボタン等 */
  extra?: ReactNode;
  /** タイトルレベル（デフォルト: 3） */
  level?: 1 | 2 | 3 | 4 | 5;
}

/**
 * 統一されたページヘッダーコンポーネント
 *
 * WorkHistoryPage のパターンを基準に、全ページで統一的に使用する。
 *
 * @example
 * ```tsx
 * <PageHeader
 *   title="作業履歴一覧"
 *   subtitle="作業の記録を検索・分析し、詳細を確認できます。"
 *   extra={
 *     <Button icon={<HistoryOutlined />} onClick={handleRefresh}>
 *       最新の情報を取得
 *     </Button>
 *   }
 * />
 * ```
 */
export function PageHeader({
  title,
  subtitle,
  icon,
  extra,
  level = 3,
}: PageHeaderProps): JSX.Element {
  return (
    <Row justify="space-between" align="middle">
      <Col>
        <Space direction="vertical" size={4}>
          <Title level={level} style={{ marginBottom: 0 }}>
            {icon && <span style={{ marginRight: 8 }}>{icon}</span>}
            {title}
          </Title>
          {subtitle &&
            (typeof subtitle === 'string' ? (
              <Text type="secondary">{subtitle}</Text>
            ) : (
              <div>{subtitle}</div>
            ))}
        </Space>
      </Col>
      {extra && (
        <Col>
          <Space>{extra}</Space>
        </Col>
      )}
    </Row>
  );
}
